import { render, staticRenderFns } from "./read-drd-caption.component.vue?vue&type=template&id=7fb6a9f0&scoped=true&"
import script from "./read-drd-caption.component.vue?vue&type=script&lang=ts&"
export * from "./read-drd-caption.component.vue?vue&type=script&lang=ts&"
import style0 from "./read-drd-caption.component.vue?vue&type=style&index=0&id=7fb6a9f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb6a9f0",
  null
  
)

export default component.exports